import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import '../styles/Match.css';
import '../styles/App.css';
import Ticket from './ticket/Ticket.jsx';

// Component for matches used in coming and past matches

const Match = ({ eventId, matchInfo, tickets, setMatchData }) => {
  const [open, setOpen] = useState(false);
  const matchDate = new Date(matchInfo.eventDate);

  return (
    <div className="match-rectangle">
      <div className="match-header" onClick={() => setOpen(!open)}>

        <div className="match-info">{matchInfo.eventName} {matchDate.getDate()}.{matchDate.getMonth() + 1}.{matchDate.getFullYear()}</div>
        <button className="arrow-btn">
          {open 
            ? <KeyboardArrowUpIcon style={{ fontSize: 36 }} /> 
            : <KeyboardArrowDownIcon style={{ fontSize: 36 }} />
          }
        </button>
      </div>
      {open && (
        <div className="tickets-list">
          {tickets.map( (ticket, index) => 
          <Ticket
            key={ticket.ticketId}
            index={index + 1}
            emailCanBeEdited={!(matchDate < new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))}
            ticketId={ticket.ticketId} 
            priceType={ticket.priceType} 
            seatDetails={ticket.seatDetails} 
            customerEmail={ticket.customerEmail}
            visitorEmail={ticket.visitorEmail}
            setMatchData={setMatchData}
          />
          )}
        </div>
      )}
    </div>
  );
};

export default Match;
